import React, { useRef } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import Icons from 'assets/images/Icons';
import iconsIndex from 'assets/images/Icons/iconsIndex';

type ISortIcon = {
  className: string|undefined
  headerKey: number
  name: keyof typeof iconsIndex
}

const SortIcon = ({ name, className }: ISortIcon) => {
  const animationRef = useRef(null);

  return (
    <SwitchTransition>
      <CSSTransition
        classNames='fade'
        nodeRef={animationRef}
        timeout={0}
        key={name}
      >
        <span ref={animationRef}>
          <Icons name={name} className={className} />
        </span>
      </CSSTransition>
    </SwitchTransition>
  );
};

export default SortIcon;
